import _defineProperty from "/Users/jamieschaedel/Sites/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/jamieschaedel/Sites/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.reduce.js";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { helpers } from "@elastic/search-ui";

function adaptFilterType(type) {
  if (type === "any") return {};
  if (type === "all") return {
    type: "and"
  };
  return {
    type: "and"
  };
}

export function adaptFacetConfig(facets) {
  if (!facets) return;

  var convertInvalidFacetsToUndefined = function convertInvalidFacetsToUndefined(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        fieldName = _ref2[0],
        config = _ref2[1];

    if (config.type != "value") {
      console.warn("search-ui-site-search-connector: Dropping ".concat(fieldName, " facet, only value facets are supported in Site Search"));
      return undefined;
    }

    if (config.sort) {
      console.warn("search-ui-site-search-connector: Site Search does not support 'sort' on facets");
    }

    if (config.size) {
      console.warn("search-ui-site-search-connector: Site Search does not support 'size' on facets");
    }

    return [fieldName, config];
  };

  var config = Object.entries(facets).map(convertInvalidFacetsToUndefined).filter(function (v) {
    return v;
  }) // filter out undefined
  .map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return key;
  }); // get keys

  if (!config.length) return;
  return config;
}
export function adaptFilterConfig(filters) {
  if (!filters || Object.keys(filters).length === 0) return;
  return filters.reduce(function (acc, filter) {
    var fieldName = filter.field;
    var fieldValue = filter.values;

    if (acc[fieldName]) {
      console.warn("search-ui-site-search-connector: More than one filter found for a single field");
      return acc;
    }

    if (filter.type && filter.type !== "all" && filter.type !== "any") {
      console.warn("search-ui-site-search-connector: Unsupported filter type \"".concat(filter.type, "\" found, only \"all\" and \"any\" are currently supported"));
      return acc;
    }

    if (fieldValue.find(function (v) {
      return typeof v === "object";
    }) !== undefined) {
      if (fieldValue.length > 1) {
        console.warn("search-ui-site-search-connector: Cannot apply more than 1 none-value filters to a single field");
        return acc;
      }

      var firstValue = fieldValue[0];

      if (helpers.isFilterValueRange(firstValue)) {
        // eslint-disable-next-line
        var name = firstValue.name,
            rest = __rest(firstValue, ["name"]);

        acc[fieldName] = Object.assign({
          type: "range"
        }, rest);
        return acc;
      } else {
        return acc;
      }
    }

    acc[fieldName] = Object.assign(Object.assign({}, adaptFilterType(filter.type)), {
      values: fieldValue
    });
    return acc;
  }, {});
}
export function adaptResultFieldsConfig(resultFieldsConfig) {
  if (!resultFieldsConfig) return [];
  var fetchFields = Object.keys(resultFieldsConfig);
  var highlightFields = Object.entries(resultFieldsConfig).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        fieldName = _ref6[0],
        fieldConfig = _ref6[1];

    if (!fieldConfig.snippet) return acc;
    return Object.assign(Object.assign({}, acc), _defineProperty({}, fieldName, fieldConfig.snippet));
  }, {});
  return [fetchFields, highlightFields];
}
export function adaptSearchFieldsConfig(searchFieldsConfig) {
  if (!searchFieldsConfig) return [];
  return Object.keys(searchFieldsConfig);
}